module.exports = __webpack_public_path__ + "static/media/Privacy_Policy_English.7ce5e3e3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Privacy_Policy_English.pdf
// module id = 1501
// module chunks = 0